<script>
import { Line } from "vue-chartjs";
export default {
  extends: Line,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    componentkey: Number
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
  watch: {
    componentkey() {
      this.renderChart(this.chartdata, this.options);
    }
  }
};
</script>